import m from 'mithril';
import modalCloseButton from '../../../components/modalCloseButton';

const modal = {
  key: 'USER_AUTH_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', 'Create New Trigger'),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m('form', [
                      m('div.form-group', [
                        m('label', 'Driver Name:'),
                        m('input.form-control[type="text"]', {
                          oninput: (e) => state.driverName = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Phone Number:'),
                        m('input.form-control[type="tel"]', {
                          oninput: (e) => state.driverPhoneNumber = e.target.value,
                        }),
                      ]),
                    ]),
                  ]),
                m('.modal-footer',
                  [
                    
                    m('button.btn.btn-primary[type="button"]', {
                      onclick() {
                        if (!state.driverName || !state.driverPhoneNumber) {
                          alert('Please fill in both fields');
                          return;
                        }
                        state.loading = true;
                        m.redraw();
                        // some async tings
                        setTimeout(() => {
                          // Create new driver logic goes here
                          console.log(`Created new driver: ${state.driverName} - ${state.driverPhoneNumber}`);
                          state.loading = false;
                          m.redraw();
                          modal.hide();
                        }, 2000);
                      },
                    }, 'Continue'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
